import type { WizardConfig } from '@/wizard/types.ts';
import { wizardStepMeta } from '@/wizard/step-meta.ts';
import { CounterpartyStepCode } from '@/modules/counterparty/counterparty-master/enums/step-code.ts';
import type { CounterpartyMasterWizardData } from '@/modules/counterparty/counterparty-master/types/wizard-data.ts';
import { isMasterSectionVisible } from '@/modules/counterparty/counterparty-master/utils/counterparty-master-access.util.ts';
import StepName from '@/modules/counterparty/counterparty-master/steps/StepName.vue';
import StepManager from '@/modules/counterparty/counterparty-master/steps/StepManager.vue';
import StepAddress from '@/modules/counterparty/counterparty-master/steps/StepAddress.vue';
import StepContact from '@/modules/counterparty/counterparty-master/steps/StepContact.vue';
import StepBankDetails from '@/modules/counterparty/counterparty-master/steps/StepBankDetails.vue';
import StepSubordination from '@/modules/counterparty/counterparty-master/steps/StepSubordination.vue';
import StepComment from '@/modules/counterparty/counterparty-master/steps/StepComment.vue';
import StepExecution from '@/modules/counterparty/counterparty-master/steps/StepExecution.vue';
import StepCompletion from '@/modules/counterparty/counterparty-master/steps/StepCompletion.vue';

const meta = (prefix: string, menuTitle = `${prefix}.menuTitle`) => wizardStepMeta(`${prefix}.title`, '', menuTitle);

export const COUNTERPARTY_MASTER_WIZARD_CONFIG: WizardConfig<CounterpartyMasterWizardData, CounterpartyStepCode> = {
  steps: [
    {
      code: CounterpartyStepCode.Name,
      component: StepName,
      ...meta('counterparty.master.steps.name'),
      visible: (data) => data.access.counterparty,
    },
    {
      code: CounterpartyStepCode.Manager,
      component: StepManager,
      ...meta('counterparty.master.steps.manager'),
      visible: (data) => data.access.counterparty,
      navigation: { completeAsNext: true },
    },
    {
      code: CounterpartyStepCode.Address,
      component: StepAddress,
      ...meta('counterparty.master.steps.address'),
      visible: (data) => isMasterSectionVisible('addresses', data.sections, data.access),
      navigation: { completeAsNext: true },
    },
    {
      code: CounterpartyStepCode.Contact,
      component: StepContact,
      ...meta('counterparty.master.steps.contact'),
      visible: (data) => isMasterSectionVisible('contacts', data.sections, data.access),
      navigation: { completeAsNext: true },
    },
    {
      code: CounterpartyStepCode.BankDetails,
      component: StepBankDetails,
      ...meta('counterparty.master.steps.bankDetails'),
      visible: (data) => isMasterSectionVisible('bankDetails', data.sections, data.access),
      navigation: { completeAsNext: true },
    },
    {
      code: CounterpartyStepCode.Subordination,
      component: StepSubordination,
      ...meta('counterparty.master.steps.subordination'),
      visible: (data) => isMasterSectionVisible('subordination', data.sections, data.access),
      navigation: { completeAsNext: true },
    },
    {
      code: CounterpartyStepCode.Comment,
      component: StepComment,
      ...meta('counterparty.master.steps.comment'),
      visible: (data) => isMasterSectionVisible('comment', data.sections, data.access),
      navigation: { completeAsNext: true },
    },
    {
      code: CounterpartyStepCode.Execution,
      component: StepExecution,
      ...meta('counterparty.master.steps.execution', 'shared.execution'),
      visible: (data) => data.access.execution,
      navigation: { onlyNext: true, hideNext: true },
    },
    {
      code: CounterpartyStepCode.Completion,
      component: StepCompletion,
      ...meta('counterparty.master.steps.completion'),
      visible: (data) => data.access.execution,
      navigation: { onlyNext: true, completeAsClose: true },
    },
  ],
};
